import { Table } from '@tanstack/react-table';
import classNames from 'classnames/bind';
import { useIntl } from 'react-intl';
import { formatAmountCurrency } from 'utils/numberUtils';
import { type CleosTableFeaturesType } from '../tableFeatures';
import styles from '../styles.module.scss';

const cx = classNames.bind(styles);

interface SumRowProps<TData extends object> {
  table: Table<CleosTableFeaturesType, TData>;
  expandable?: boolean;
}

export const SumRow = <TData extends object>({ table, expandable }: SumRowProps<TData>) => {
  const intl = useIntl();
  const visibleColumns = table.getVisibleLeafColumns();
  const filteredRows = table.getFilteredRowModel().rows;

  return (
    <tr className={styles.sumRow}>
      {expandable && <td className={cx({ td: true })}>{intl.formatMessage({ id: 'generalValues.sum' })}</td>}

      {visibleColumns.map((column, i) => {
        const meta = column.columnDef.meta;
        const cellClasses = cx({ td: true, number: meta?.number || meta?.amount });

        if (i === 0 && !expandable) {
          return (
            <td className={cellClasses} key="sum-label">
              {intl.formatMessage({ id: 'generalValues.sum' })}
            </td>
          );
        }

        if (!meta?.sumable) return <td className={cellClasses} key={column.id} />;

        const sum = filteredRows.reduce((acc, row) => {
          const val = parseFloat(String(row.getValue(column.id) ?? 0));
          return acc + (isNaN(val) ? 0 : val);
        }, 0);

        return (
          <td className={cellClasses} key={column.id}>
            {formatAmountCurrency(sum)}
          </td>
        );
      })}
    </tr>
  );
};
